module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "odiv"
    }
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "row-key": "rowkey",
      "border": "",
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "medicineName",
      "label": "药品名称",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "saleNunmber",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "medicineUnit",
      "label": "单位",
      "width": "auto"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "20px 10px"
    },
    attrs: {
      "plain": true,
      "type": "info"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0274570","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/checkout.vue
// module id = 1038
// module chunks = 2